<div id="sustainability-dashboard">
  <div class="header-section">
    <div class="header-top">
      <div>
        <p class="header-title">Sustainability Dashboard</p>
        <p class="header-description">Track and monitor sustainability metrics across different aspects</p>
      </div>
      @if (!enterprisesLoading()) {
        <div class="enterprise-selection-container">
          <div class="enterprise-selection">
            <span class="enterprise-selection-label">{{ 'doktar_app.home.selected_enterprise' | translate }}</span>
            <p-select
              [options]="userEnterprises()"
              [ngModel]="selectedEnterprise()"
              (ngModelChange)="onSelectEnterpriseFromModel($event)"
              optionLabel="name">
              <ng-template #selectedItem let-selectedOption>
                <div class="selected-enterprise">
                  <div class="enterprise-name-w-icon">
                    <i class="ph-fill ph-handshake"></i>
                    <span>{{ selectedOption.name }}</span>
                  </div>
                </div>
              </ng-template>
            </p-select>
          </div>
        </div>
      } @else {
        <p-skeleton width="200px" height="44px" borderRadius="16px" />
      }
    </div>
  </div>
  @if (enterprisesLoading()) {
    <div class="page-loading-skeleton mt-3">
      <div class="d-flex align-items-center gap-3 mb-3">
        <p-skeleton width="450px" height="28px" borderRadius="6px" />
      </div>
      <div class="d-flex gap-4 mb-3">
        <p-skeleton width="50px" height="18px" />
        <p-skeleton width="50px" height="18px" />
        <p-skeleton width="42px" height="18px" />
        <p-skeleton width="65px" height="18px" />
        <p-skeleton width="85px" height="18px" />
        <p-skeleton width="75px" height="18px" />
      </div>
      <p-skeleton width="100%" height="500px" borderRadius="12px" />
    </div>
  } @else if (selectedEnterprise()) {
    @if (loading()) {
      <div class="contracts-loading mt-3">
        <p-skeleton width="450px" height="28px" />
      </div>
    } @else if (showContractsEmptyState()) {
      <app-sustainability-dashboard-empty-contracts
        [wasThereError]="contractsLoadError()"
        (tryAgainEvent)="onRefresh()" />
    } @else {
      <div class="row contracts-row">
        <div class="col-12 d-flex gap-4 align-items-start">
          <div class="d-flex flex-column contracts-field-column">
            <span class="contracts-field-label">{{ 'doktar_app.account.enterprises.contracts' | translate }}</span>
            <div class="custom-field-container">
              <p-select
                id="sustainability-dashboard-contracts-select"
                name="contracts"
                [options]="contractOptions()"
                [ngModel]="selectedContractId()"
                (ngModelChange)="onSelectContractId($event)"
                optionLabel="contractName"
                optionValue="contractId"
                placeholder="Select a contract"
                (onChange)="onSelectContract()" />
            </div>
          </div>
          <div class="d-flex flex-column contracts-field-column">
            <span class="contracts-field-label">{{ 'doktar_app.csi.subcontracts' | translate }}</span>
            <div class="custom-field-container">
              <p-select
                id="sustainability-dashboard-subcontracts-select"
                name="subcontracts"
                [options]="subcontractOptions()"
                [ngModel]="selectedSubcontractId()"
                (ngModelChange)="onSelectSubcontractId($event)"
                optionLabel="value"
                optionValue="key"
                placeholder="Choose a sub-contract"
                [showClear]="true"
                (onChange)="onSelectSubcontract()" />
            </div>
          </div>
        </div>
      </div>

      <div class="tabs pb-3">
        <div class="d-flex gap-4">
          @for (tab of tabOptions; track tab.value) {
            @if (tab.show) {
              <span
                class="tab-item"
                [class.active]="selectedTab() === tab.value"
                (click)="onSelectTab(tab.value)">
                {{ tab.label }}
              </span>
            }
          }
        </div>
      </div>

      <router-outlet />
    }
  }
</div>
